import localFont from 'next/font/local';

const Biotif = localFont({
  variable: '--biotif-font',
  src: [
    {
      path: '../assets/fonts/Biotif-Light.woff',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-LightItalic.woff',
      weight: '300',
      style: 'italic',
    },
    {
      path: '../assets/fonts/Biotif-Book.woff',
      weight: '350',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-BookItalic.woff',
      weight: '350',
      style: 'italic',
    },
    {
      path: '../assets/fonts/Biotif-Regular.woff',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-RegularItalic.woff',
      weight: '400',
      style: 'italic',
    },
    {
      path: '../assets/fonts/Biotif-Medium.woff',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-MediumItalic.woff',
      weight: '500',
      style: 'italic',
    },
    {
      path: '../assets/fonts/Biotif-SemiBold.woff',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-SemiBoldItalic.woff',
      weight: '600',
      style: 'italic',
    },
    {
      path: '../assets/fonts/Biotif-Bold.woff',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-BoldItalic.woff',
      weight: '700',
      style: 'italic',
    },
    {
      path: '../assets/fonts/Biotif-ExtraBold.woff',
      weight: '800',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-ExtraBoldItalic.woff',
      weight: '800',
      style: 'italic',
    },
    {
      path: '../assets/fonts/Biotif-Black.woff',
      weight: '900',
      style: 'normal',
    },
    {
      path: '../assets/fonts/Biotif-BlackItalic.woff',
      weight: '900',
      style: 'italic',
    },
  ],
});

export default Biotif;
